import {FC} from "react";
import { OutlinedButton } from "../../components/Buttons";
import { useTheme } from "@mui/material/styles";
import { styled } from "@mui/material/styles";

const MainContainer = styled("div")(({ theme }) => ({
  width:'500px',
  margin:'0px auto',
  textAlign:'center',

  marginBottom:'50px',

  [theme.breakpoints.down('sm')]:{
    width:'90%'
  }
}));

const SubContainer = styled("div")(({ theme }) => ({
  width: '100%',
  padding:'30px 20px',
  backgroundColor: theme.palette.primary.main,
  borderRadius:'8px',
  marginTop:'15px',
  textAlign:'left'
}));

const Label = styled("h1")(({ theme }) => ({
  fontSize:'18px',
  fontFamily:'Poppins',
  fontWeight:'500',
  color: theme.palette.background.default,
  marginBottom:'5px',
}));

const InputField = styled("input")(({ theme }) => ({
  fontSize:'18px',
  fontFamily:'Poppins',
  fontWeight:'500',
  backgroundColor: theme.palette.background.default,
  color: theme.palette.primary.main,
  width:'100%',
  border:'none',
  borderRadius:'8px',
  outline:'none',
  padding:'7px 18px',
  marginBottom:'20px'
}));

const InputArea = styled("textarea")(({ theme }) => ({
  fontSize:'18px',
  fontFamily:'Poppins',
  fontWeight:'500',
  backgroundColor: theme.palette.background.default,
  color: theme.palette.primary.main,
  width:'100%',
  border:'none',
  borderRadius:'8px',
  outline:'none',
  padding:'7px 18px',
  marginBottom:'10px',
  resize: 'vertical',
  minHeight:'50px',
}));


const AdProposalForm: FC = () => {
  const theme = useTheme();

  return (
    
    <MainContainer>
    <div style={{fontSize:'40px', fontFamily: 'Righteous' , color:theme.palette.primary.main, margin:'0px auto'}}>
      Advertisement Proposal
    </div>
    
    <SubContainer>
      <Label>Advertiser Name :</Label>
      <InputField placeholder="Enter Advertiser Name"/>

      <Label>Advertisement Details :</Label>
      <InputArea placeholder="Enter Advertisement Details" rows={3} />

      <Label>Advertisement Budget :</Label>
      <InputField placeholder="Enter Advertiser Budget"/>

      <Label>Advertisement Date :</Label>
      <InputField placeholder="Enter Advertiser Date" type={'date'}/>

      <Label>Banner Image :</Label>
      <InputField placeholder="Enter Banner Image Url"/>

      <Label>Pop-up Image :</Label>
      <InputField style={{marginBottom:'10px'}} placeholder="Enter Pop-up Image Url"/>

    </SubContainer>

    <OutlinedButton
        type="submit"
        style={{width:'calc( 100% - 4px )',marginTop:'20px'}}
      >
        Create Ad Proposal
      </OutlinedButton>

  </MainContainer>

  );
};

export default AdProposalForm;
